import { createFileRoute, Link } from '@tanstack/react-router'
import { css } from '../../../../styled-system/css'
import ArrowForward from '~icons/material-symbols/arrow-forward.svg'
import Add from '~icons/material-symbols/add.svg'
import { button } from '../../../styles/buttonStyles'
import { table, tableHead, tableHeadCell, tableRow, tableCell, tableWrapper } from '../../../styles/tableStyles'
import { pageTitle, titleWrapper } from '../../../styles/sectionStyles'
import { contentWrapper } from '../../../styles/contentWrapper'
import { useGetAllFundSources } from '../../../libs/admin/hooks'
import { LoadingOverlay } from '../../../components/loading-overlay'
import { TablePaginationToolbar } from '../../../components/table-pagination-toolbar'
import { useState } from 'react'

export const Route = createFileRoute('/admin/points/')({
  component: RouteComponent,
})

const DATA_PER_PAGE = 15

const TableContent = () => {
  const { data, isFetching } = useGetAllFundSources()
  const fundSources = (data || []).filter((e) => e.type === "Distributable")
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil((fundSources?.length ?? 0) / DATA_PER_PAGE)
  const startIndex = page * DATA_PER_PAGE
  const endIndex = startIndex + DATA_PER_PAGE
  const paginatedData = fundSources?.slice(startIndex, endIndex) ?? []

  return (
    <div className={tableWrapper()}>
      <TablePaginationToolbar
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
      />
      <table className={table()}>
        <thead className={tableHead()}>
          <tr>
            <th className={tableHeadCell()}>表示名</th>
            <th className={tableHeadCell()}>譲渡</th>
            <th className={tableHeadCell()}>ポイントID</th>
            <th className={tableHeadCell()}>内部メモ</th>
            <th className={tableHeadCell()} />
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item) => (
            <tr className={tableRow()} key={item.id}>
              <td className={tableCell()}>{item.name}</td>
              <td className={tableCell()}>{item.forbidTransfer ? '不可' : '可'}</td>
              <td className={tableCell()}>{item.id.slice(0, 8)}</td>
              <td className={tableCell()}>{item.note ?? ""}</td>
              <td className={tableCell()}>
                <div className={css({
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                })}>
                  <Link to={'/admin/points/$fundSourceId'} params={{ fundSourceId: item.id }}>
                  <button type='button' className={button()}>詳細<ArrowForward /></button>
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {isFetching && <LoadingOverlay />}
    </div>
  )
}

function RouteComponent() {
  return (
    <div className={contentWrapper()}>
      <div className={titleWrapper()}>
        <h1 className={pageTitle()}>ポイント種類</h1>
        <div className={css({ flex: 1 })} />
        <div className={css({
          display: 'flex',
          gap: '8px',
        })}>
          <Link to='/admin/points/bulkGrantPoints'>
            <button type='button' className={button()}>
              <Add />
              ポイント一括付与
            </button>
          </Link>
          <Link to='/admin/points/bulkCreateStandaloneDistributionCodes'>
            <button type='button' className={button()}>
              <Add />
              配布コード一括作成
            </button>
          </Link>
        </div>
      </div>
      <div className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      })}>
        <TableContent />
      </div>
    </div>
  )
}
